import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { DynamicsAXCopySource } from 'app/model/pipeline/copysource/dynamics-ax.copysource';
import { ValueAdapter } from '../../value.adapter';
import { stringIsNullOrEmpty } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsAXCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        httpRequestTimeout: '*'
    }
})
export class DynamicsAXCopySourceAdapter extends CopySourceAdapter<DynamicsAXCopySource, Model.DynamicsAXSource> {
    protected override async _toResource(copySource: DynamicsAXCopySource): Promise<Model.DynamicsAXSource> {
        const resource: Model.DynamicsAXSource = this._toTabularResource(
            copySource,
            Metamodel.modelFor(DynamicsAXCopySource).name
        );
        resource.httpRequestTimeout = ValueAdapter.toResource(copySource, DynamicsAXCopySource.HTTP_REQUEST_TIMEOUT);
        // clear out '' from resource, backend doesn't support ''
        if (stringIsNullOrEmpty(resource.httpRequestTimeout)) {
            resource.httpRequestTimeout = undefined;
        }
        return resource;
    }

    protected override async _toModel(
        resource: Model.DynamicsAXSource,
        copyActivity: CopyActivity
    ): Promise<DynamicsAXCopySource> {
        const result: DynamicsAXCopySource = this._toTabularModel(resource, copyActivity, DynamicsAXCopySource.MODEL);
        if (resource.httpRequestTimeout != null) {
            ValueAdapter.toModel(result, DynamicsAXCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        } else {
            // clear default value for all existing resources
            result.httpRequestTimeout = undefined;
        }
        return result;
    }
}
